import { Injectable } from '@angular/core';
import { Observable ,  Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../../interfaces/app-state.interface';

@Injectable()
export class NotificationsQueueService {
    public queueItensObservable$: Observable<any>;
    private _queueItensObservableSubject: Subject<any>;
    private itens: Array<object> = [];
    constructor(
        private store: Store<AppState>,
    ) {
        this._queueItensObservableSubject = new Subject();
        this.queueItensObservable$ = this._queueItensObservableSubject.asObservable();
    }
    /**
     * interfaces for websocket!!
     */
    getAndUpdate_QueueItens() {
        this.itens = [];
    }
    removeQueueItem(index) {
        this.itens.splice(index, 0);
    }
}